export default {
  'user.login.password.required': 'Please enter your password.',
  'user.login.password.required.placeholder': 'Enter password',
  'user.loginOrRegister.email': 'Email',
  'user.loginOrRegister.captcha.placeholder': 'Paste verification code',
  'user.loginOrRegister.captcha.sendEmail': 'Send Code',
  'user.loginOrRegister.rule.required.captcha': 'Please enter the verification code',
  'user.loginOrRegister.rule.required.mail': 'Please enter email',
  'user.loginOrRegister.rule.pattern.mail': 'Please enter correct email format',
  'user.login.password.tooManyErrors':
    'You have entered too many password errors, please try again later.',
  'user.request.message.rateLimit': 'Requesting too frequently, access restricted, try again later',
  'user.login.message.invalidCaptcha': 'The verification code is invalid',
  'user.login.message.invalidCaptcha.tip': 'The verification code is incorrect, please try again',
  'user.login.password.error': 'Password error, please try again!',
};
